module.exports = __webpack_public_path__ + "images/img-3tAr3QZ.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/4.png
// module id = 2353
// module chunks = 0